import md5 from 'md5';

export const getGravatar = (
  authorEmail: string = 'no email available',
  queryParams: string = '',
) => {
  // Use md5 to generate the hash of the author's email that Gravatar needs to find the avatar
  const gravatarHash = md5(authorEmail);
  return (
    'https://www.gravatar.com/avatar/' +
    gravatarHash +
    `?${queryParams}d=https://secure.gravatar.com/avatar/b9fa8353122853002d8dcffc2c775182.jpg?s=75&amp;r=G`
  );
};
